import classNames from 'classnames';
import { ReactNode } from 'react';

export const ExternalLink = ({
  href,
  children,
  underline = false,
  className,
}: {
  className?: string;
  href: string;
  children: ReactNode;
  underline?: boolean;
}) => (
  <a
    className={classNames('u-color-pine4 hover:u-color-willow', className, {
      'text-decoration-underline': underline,
    })}
    href={href}
    rel="noreferrer"
  >
    {children}
  </a>
);
